module.exports = __webpack_public_path__ + "media/images/cbjj/ranking-bg-2ccd386068611b3ab78b394c7defbb95.jpg";